import React from 'react';
import { usePhoneTheme } from './theme';

/** Original mark. Light mode always uses this file. */
export const MARK_SRC = '/lgl-mark.png';

/**
 * Dark-mode mark (white G, same red L’s). Replace this file with a
 * Photoshop export to refine the last bit of fringe — same 232×232
 * RGBA PNG, transparent corners.
 */
export const MARK_DARK_SRC = '/lgl-mark-dark.png';

export const LglMark = ({ className, title = 'LGL' }) => (
  <img className={className} src={MARK_SRC} alt={title} />
);

export const BrandMark = () => {
  const { theme } = usePhoneTheme();
  const dark = theme === 'dark';
  return (
    <span className={dark ? 'lgl-m-mark lgl-m-mark--darkg' : 'lgl-m-mark'} title="LGL">
      <img src={dark ? MARK_DARK_SRC : MARK_SRC} alt="LGL" />
    </span>
  );
};

export default LglMark;
